import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ProjectEnvConfig } from './ProjectEnvConfigExtension';

export const ProjectEnvConfigExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProjectEnvConfigExtension',
    component: ProjectEnvConfig,
  }),
);
